export const managementFeeFrequencies = ['Unknown', 'Monthly', 'Quarterly', 'Half yearly', 'Annually', 'Other'];
export function emptyManagementFees() { return { effectiveFrom: null, effectiveTo: null, lines: [{ label: 'Management fee', basis: 'Unknown', amount: null, count: null }], vat: { treatment: 'Unknown', rate: null }, frequency: 'Unknown', frequencyDetail: '', paymentTerms: '', onboarding: { state: 'Unknown', amount: null, vat: { treatment: 'Unknown', rate: null }, invoiceDate: null, paymentTerms: '', explanation: '' }, notes: '' }; }
const pennies = (v) => { if (!/^(?:0|[1-9]\d{0,10})(?:\.\d{1,2})?$/.test(v))
    throw Error('Use a non-negative amount with at most two decimal places.'); const [w, f = ''] = v.split('.'); return BigInt(w) * 100n + BigInt(f.padEnd(2, '0')); };
const decimal = (v) => `${v / 100n}.${(v % 100n).toString().padStart(2, '0')}`;
const halfUp = (n, d) => (n * 2n + d) / (d * 2n);
function tax(amount, vat) {
    if (vat.treatment === 'Unknown')
        return { net: null, vat: null, gross: null };
    if (vat.treatment === 'Not applicable')
        return { net: decimal(amount), vat: '0.00', gross: decimal(amount) };
    if (vat.rate === null)
        return { net: vat.treatment === 'Exclusive' ? decimal(amount) : null, vat: null, gross: vat.treatment === 'Inclusive' ? decimal(amount) : null };
    const rate = pennies(vat.rate);
    if (rate > 10000n)
        throw Error('VAT rate cannot exceed 100%.');
    const net = vat.treatment === 'Exclusive' ? amount : halfUp(amount * 10000n, 10000n + rate), gross = vat.treatment === 'Inclusive' ? amount : amount + halfUp(amount * rate, 10000n);
    return { net: decimal(net), vat: decimal(gross - net), gross: decimal(gross) };
}
/** Commercial fees and invoice amounts retain pennies; planned-budget rounding does not apply. */
export function assessManagementFees(terms) {
    const missing = [];
    let total = 0n, complete = true;
    if (!terms.effectiveFrom)
        missing.push('Fee effective date');
    if (terms.effectiveFrom && terms.effectiveTo && terms.effectiveTo < terms.effectiveFrom)
        missing.push('Fee end date must follow its start');
    if (!terms.lines.length)
        missing.push('At least one management fee line');
    const lines = terms.lines.map((l, i) => {
        const label = l.label.trim() || `Fee line ${i + 1}`;
        let amount = null;
        if (!l.label.trim())
            missing.push(`${label}: description`);
        if (l.basis === 'Unknown')
            missing.push(`${label}: fixed or per-property basis`);
        if (l.amount === null)
            missing.push(`${label}: annual amount or unit rate`);
        if (l.basis === 'Per property annually' && (l.count === null || !Number.isSafeInteger(l.count) || l.count < 0))
            missing.push(`${label}: agreed chargeable property count`);
        if (l.amount !== null && l.basis !== 'Unknown' && (l.basis !== 'Per property annually' || l.count !== null && Number.isSafeInteger(l.count) && l.count >= 0))
            amount = pennies(l.amount) * BigInt(l.basis === 'Per property annually' ? l.count : 1);
        if (amount === null)
            complete = false;
        else
            total += amount;
        return { label, annual: amount === null ? null : decimal(amount) };
    });
    if (terms.vat.treatment === 'Unknown')
        missing.push('Management fee VAT treatment');
    if (['Exclusive', 'Inclusive'].includes(terms.vat.treatment) && terms.vat.rate === null)
        missing.push('Recorded management fee VAT rate');
    if (terms.frequency === 'Unknown')
        missing.push('Management fee payment frequency');
    if (terms.frequency === 'Other' && !terms.frequencyDetail.trim())
        missing.push('Custom management fee frequency');
    if (!terms.paymentTerms.trim())
        missing.push('Management fee payment terms');
    const o = terms.onboarding;
    if (o.state === 'Unknown')
        missing.push('Onboarding fee payable, waived or included');
    if (o.state === 'Payable') {
        if (o.amount === null)
            missing.push('Onboarding fee amount');
        if (!o.invoiceDate)
            missing.push('Onboarding fee invoice date');
        if (!o.paymentTerms.trim())
            missing.push('Onboarding fee payment terms');
        if (o.vat.treatment === 'Unknown')
            missing.push('Onboarding fee VAT treatment');
        if (['Exclusive', 'Inclusive'].includes(o.vat.treatment) && o.vat.rate === null)
            missing.push('Recorded onboarding fee VAT rate');
    }
    else if (['Waived', 'Included'].includes(o.state) && !o.explanation.trim())
        missing.push('Basis for the waived or included onboarding fee');
    const annual = complete && terms.lines.length ? tax(total, terms.vat) : { net: null, vat: null, gross: null };
    const count = { Monthly: 12, Quarterly: 4, 'Half yearly': 2, Annually: 1 }[terms.frequency];
    // These are arithmetic equivalents only. Actual invoice preparation has its own dates and approval.
    const equivalents = annual.gross !== null && count ? Array.from({ length: count }, (_, i) => { const amount = pennies(annual.gross); return decimal(amount / BigInt(count) + (BigInt(i) < amount % BigInt(count) ? 1n : 0n)); }) : [];
    return { lines, annual, onboarding: o.state === 'Payable' && o.amount !== null ? tax(pennies(o.amount), o.vat) : ['Waived', 'Included'].includes(o.state) ? { net: '0.00', vat: '0.00', gross: '0.00' } : { net: null, vat: null, gross: null }, equivalents, missing, complete: !missing.length };
}
/** Tax each prepared invoice on its own agreed charge basis; never allocate annual VAT rounding between invoices. */
export function calculateManagementFeeTax(amount, vat) { return tax(pennies(amount), vat); }
//# sourceMappingURL=management-fees.js.map